import React, { FC, useContext } from 'react';
import { useIntl } from 'react-intl';

import ErrorMessage from '@components/common/form/errorMessage';
import {
    TXN_REASON,
    TXN_TYPES,
    TXN_TYPES_OPTIONS_GENERAL,
} from '@constants/enrollmentList/enrollmentList.constant';
import { INPUT_TYPES } from '@constants/inputs/inputTypes';
import Dropdown from '@lib/inputs/Dropdown';
import { changeFieldValue } from '../common/enrollmentUtils';
import { AddOrChangeTxnFormContext } from '../context/AddOrChangeTxnProvider';
import { StyledField } from '../styles/EnrollmentSharedStyled';

const EnrollmentTransactionTypeDropdown: FC = () => {
    const intl = useIntl();

    const {
        watch,
        formState: { errors },
        setValue,
        clearErrors,
        setError,
    } = useContext(AddOrChangeTxnFormContext);
    const values = watch();

    const updateSubscriberTxnType = value => {
        clearErrors('enrolleeEndDateUnchanged');
        const enrolleeDataDtoList = values.enrolleeDataDtoList.map(function (enrollee) {
            let txnType = value;
            let txnReason = enrollee.txnReason;
            if (value == TXN_TYPES.Change) {
                txnReason = TXN_REASON.TwentyNine;
            }
            if (value == TXN_TYPES.Term) {
                txnReason = TXN_REASON.AI;
            }

            return { ...enrollee, txnType, txnReason };
        });
        changeFieldValue(setValue, 'enrolleeDataDtoList', enrolleeDataDtoList);
        changeFieldValue(setValue, 'enrollmentLevelTxnType', value);
    };

    return (
        <section>
            <StyledField>
                <Dropdown
                    label={{
                        text: intl.formatMessage({
                            id: 'member.enrollment_list.label.enrollmentTransactionType',
                        }),
                        labelClass: [''],
                    }}
                    inputData={{
                        inputClasses: [''],
                        options: TXN_TYPES_OPTIONS_GENERAL,
                        type: INPUT_TYPES.DROPDOWN,
                        value: values.enrollmentLevelTxnType,
                        isInputRequired: false,
                    }}
                    inputActions={{
                        handleFieldChange: updateSubscriberTxnType,
                    }}
                />
            </StyledField>
            <ErrorMessage
                isVisible={errors?.enrollmentLevelTxnType}
                messageText={errors?.enrollmentLevelTxnType?.message}
            />
        </section>
    );
};

export default EnrollmentTransactionTypeDropdown;
